export default {"src":"/_next/static/media/panelles_regular.7171a2fe.svg","height":24,"width":24};